<div class="ticket-card-terminal">
    <upp-dialog-header>
        <ion-header>
            <ion-toolbar color="warning">
                <ion-title slot="start" uppDataid="pinpad-amount">
                    {{tr(operation === 'REFUND' ? '@ticket_refund_title' : '@ticket_paycard_title', [ price(AmountToPay), tr('@currency') ])}}
                </ion-title>
                <ion-buttons *ngIf="CanClose" slot="end">
                    <ion-button uppDataid="pinpad-close-button" (click)="OnCloseClick()">
                        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
    </upp-dialog-header>

    <upp-dialog-content>
        <div class="ticket-card-terminal__body" uppDataid="pinpad-status">
            <ng-container *ngIf="screen === 'WAITING'">
                <div class="ticket-card-terminal__progress">
                    <ion-spinner name="crescent"></ion-spinner>
                    <ion-label class="ticket-card-terminal__status" uppDataid="pinpad-checking">
                        {{tr(operation === 'REFUND' ? '@ticket_cardterm_refund_checking' : '@ticket_cardterm_checking')}}
                    </ion-label>
                </div>
            </ng-container>

            <ng-container *ngIf="screen === 'WAITING_IDLE'">
                <ion-card class="ticket-card-terminal__card ticket-card-terminal__card--warning">
                    <ion-icon name="help-circle" color="warning"></ion-icon>
                    <ion-card-title color="warning" uppDataid="pinpad-waiting-idle">{{tr('@ticket_cardterm_unlock_unreachable')}}</ion-card-title>
                    <ion-card-content *ngIf="pendingHint" uppDataid="pinpad-failure-hint">
                        {{tr(operation === 'REFUND' ? '@ticket_cardterm_refund_pending_hint' : '@ticket_cardterm_pending_hint')}}
                    </ion-card-content>
                </ion-card>
            </ng-container>

            <ng-container *ngIf="screen === 'CONFIRM'">
                <ion-card class="ticket-card-terminal__card ticket-card-terminal__card--warning">
                    <ion-icon name="help-circle" color="warning"></ion-icon>
                    <ion-card-title color="warning">
                        {{tr(operation === 'REFUND' ? '@ticket_cardterm_refund_confirm_unverified' : '@ticket_cardterm_confirm_unverified')}}
                    </ion-card-title>
                </ion-card>
            </ng-container>

            <ng-container *ngIf="screen === 'RUNNING'">
                <div class="ticket-card-terminal__progress">
                    <ion-spinner name="crescent"></ion-spinner>
                    <ion-label class="ticket-card-terminal__status">{{tr(statusKey)}}</ion-label>
                </div>
            </ng-container>

            <ng-container *ngIf="screen === 'APPROVED'">
                <ion-card class="ticket-card-terminal__card ticket-card-terminal__card--success">
                    <ion-icon name="checkmark-circle" color="success"></ion-icon>
                    <ion-card-title color="success">
                        {{tr(operation === 'REFUND' ? '@ticket_cardterm_refund_status_approved' : '@ticket_cardterm_status_approved')}}
                    </ion-card-title>
                    <ion-card-content *ngIf="alreadyApproved">
                        {{tr(operation === 'REFUND' ? '@ticket_cardterm_refund_already_approved' : '@ticket_cardterm_already_approved')}}
                    </ion-card-content>
                </ion-card>
            </ng-container>

            <ng-container *ngIf="screen === 'FAILED'">
                <ion-card class="ticket-card-terminal__card ticket-card-terminal__card--danger">
                    <ion-icon name="alert-circle" color="danger"></ion-icon>
                    <ion-card-title color="danger" uppDataid="pinpad-failure-text">
                        {{tr(failKey || (operation === 'REFUND' ? '@ticket_cardterm_refund_failed' : '@ticket_cardterm_failed'))}}
                    </ion-card-title>
                </ion-card>
            </ng-container>

            <p *ngIf="ShowTerminalLabel" class="ticket-card-terminal__terminal">
                {{TerminalLabel}}
            </p>
        </div>
    </upp-dialog-content>

    <upp-dialog-footer class="ticket-card-terminal__footer">
        <ion-button
            *ngIf="screen === 'RUNNING'"
            uppDataid="pinpad-cancel-button"
            expand="block"
            fill="clear"
            color="medium"
            [disabled]="CancelDisabled"
            (click)="OnCancelClick()">
            {{tr('@ticket_cardterm_cancel')}}
        </ion-button>

        <ion-button
            *ngIf="screen === 'FAILED' && CanRetry"
            uppDataid="pinpad-retry-button"
            size="large"
            expand="block"
            color="primary"
            [disabled]="Busy"
            (click)="OnRetryClick()">
            {{tr('@ticket_cardterm_retry')}}
        </ion-button>

        <ion-button
            *ngIf="screen === 'WAITING_IDLE'"
            uppDataid="pinpad-consult-button"
            size="large"
            expand="block"
            color="primary"
            [disabled]="Busy"
            (click)="OnConsultAgainClick()">
            {{tr('@ticket_cardterm_consult_again')}}
        </ion-button>

        <ion-button
            *ngIf="(screen === 'FAILED' || screen === 'RUNNING' || screen === 'WAITING' || screen === 'WAITING_IDLE') && CanManual"
            uppDataid="pinpad-manual-button"
            size="large"
            expand="block"
            fill="clear"
            color="primary"
            [disabled]="ManualDisabled"
            (click)="OnManualClick()">
            {{tr(operation === 'REFUND' ? '@ticket_cardterm_refund_manual' : '@ticket_cardterm_manual')}}
        </ion-button>

        <ion-button
            *ngIf="screen === 'CONFIRM'"
            uppDataid="pinpad-confirm-button"
            size="large"
            expand="block"
            color="primary"
            [disabled]="Busy"
            (click)="OnConfirmClick()">
            {{tr(operation === 'REFUND' ? '@ticket_cardterm_refund_confirm_manual' : '@ticket_cardterm_confirm_manual')}}
        </ion-button>
    </upp-dialog-footer>
</div>
